export default {
  COLORS: {
    primary: '#04152A'
  },
}